import React from "react"
import _ from "lodash"
import { formatDate, isValidDate, parseDate } from "data/lib/dates"
import { localizeNum } from "data/lib/numbers"

type NumberFieldProps = {
  rowData: object
  field: string|string[]
  readPrecision?: number
}

const NumberField = (props: NumberFieldProps) => {
  let displayValue = ""
  let propValue = _.get(props.rowData, props.field)
  if(propValue) displayValue = localizeNum(propValue, props.readPrecision)

  return <span>{displayValue}</span>
}

export default NumberField
